<dskhome-shell>
  <router-outlet />
</dskhome-shell>
